const isCallState = (state) => state === "call" || state === "partial-call" || state === "input-streaming" || state === "input-available";
const isOutputState = (state) => state === "result" || state === "output-available" || state === "output" || state === "complete";
export {
  isCallState,
  isOutputState
};
//# sourceMappingURL=types.js.map
